/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ nummer: NonNullable<unknown> }} Planning_Rooster_Lesuur_KortInputs */

const nl_planning_rooster_lesuur_kort = /** @type {(inputs: Planning_Rooster_Lesuur_KortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.nummer}e`)
};

/**

* @param {Planning_Rooster_Lesuur_KortInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_lesuur_kort = /** @type {((inputs: Planning_Rooster_Lesuur_KortInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Lesuur_KortInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_lesuur_kort(inputs)
});
export { planning_rooster_lesuur_kort as "planning.rooster.lesuur_kort" }